import React from 'react';
import { useState } from "react";

import axios from "../axios";
import { LogsRequest } from "../api/api";
import fileDownload from 'js-file-download';

import Dashboard from "../Dashboard";
import {
  Button,
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";

import { Dayjs } from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

export default function LogDump() {
  const [log, setLog] = useState<LogsRequest>({});
  const [start, setStart] = useState<Dayjs | null>(null);
  const [end, setEnd] = useState<Dayjs | null>(null);

  const handleStartDateChange = (newValue: Dayjs | null) => {
    const x = (newValue as Dayjs);
    setLog({ ...log, start: x.format('YYYY/MM/DD')});
    setStart(newValue);
  };

  const handleEndDateChange = (newValue: Dayjs | null) => {
    const x = (newValue as Dayjs)
    setLog({ ...log, end: x.format('YYYY/MM/DD')});
    setEnd(newValue);
  };

  const handleGenerate = () => {
    console.log("Generate");
    axios
      .post("/logs", log)
      .then((res) => {
        const filename = res.data.file_name.match(".+/(.+?)([\?#;].*)?$")[1];
        axios.get(res.data.file_name, {
          responseType: 'blob',
        }).then((res) => {
          fileDownload(res.data, filename)
        })
      })
      .catch((err) => {
        alert(err.response.data.message);
      });
  };

  const handleChangeServiceId = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setLog({ ...log, device_id: event.target.value });
  };

  return (
    <Dashboard title="ログ管理">
      <Table >
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="デバイスID"
                variant="outlined"
                required
                fullWidth
                value={log.device_id}
                onChange={handleChangeServiceId}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  label="開始日"
                  inputFormat="YYYY/MM/DD"
                  value={start}
                  onChange={handleStartDateChange}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  label="終了日"
                  inputFormat="YYYY/MM/DD"
                  value={end}
                  onChange={handleEndDateChange}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <br/>
      <Grid item xs={12}>
        <Button color="primary" variant="contained" onClick={handleGenerate} sx={{ m: 1 }}>
          DOWNLOAD
        </Button>
      </Grid>
    </Dashboard>
  );
}
